import { getGoogleLocationIsVerified } from './display_helpers';
import { getGoogleLocationPlaceID }    from './display_helpers';
import { isServiceAreaLocation }       from './display_helpers';
import { LocationResultView }          from './choose_location_view';
import { LocationsFailedView }         from './choose_location_view';
import { useAllLocations }             from './gmb_api';
import { useClient }                   from './google_auth';
import { useEffect }                   from 'react';
import { useState }                    from 'react';
import Alert                           from '../../components/alert';
import ConfirmButton                   from '../../components/confirm_button';
import GoogleAuth                      from './google_auth';
import Link                            from '../../components/link';
import React                           from 'react';
import Swal                            from 'sweetalert2';


export default function CurrentPlaceView({
  business,
  statuses,
  googlePlace,
  disconnectPlace,
  saveGoogleLocation,
  navigateTo,
  progressStart,
  progressEnd
}) {

  const [ offlineAccessCode, setOfflineAccessCode ] = useState();

  return (
    <GoogleAuth requireReauthorization={true}>
      {offlineAccessCode &&
        <ConnectGmb {...{
          business,
          statuses,
          googlePlace,
          offlineAccessCode,
          setOfflineAccessCode,
          saveGoogleLocation,
          navigateTo,
          progressStart,
          progressEnd
        }}/>
      }
      {!offlineAccessCode &&
        <PlaceDetails {...{
          googlePlace,
          disconnectPlace,
          setOfflineAccessCode
        }}/>
      }
    </GoogleAuth>
  );
}


function PlaceDetails({ googlePlace, disconnectPlace, setOfflineAccessCode }) {
  return (
    <div className="google-place">
      <PlaceInfo {...{ googlePlace }}/>
      <GoogleAuth.Loaded>
        <div className="block inset">
          <Alert>For a better experience managing your listing, we recommend connecting to Google My Business.</Alert>
        </div>
      </GoogleAuth.Loaded>
      <div className="block inset">
        <GoogleAuth.Loaded>
          <GmbConnectButton {...{ setOfflineAccessCode }}/>
          <DisconnectPlaceButton {...{ googlePlace, disconnectPlace }}/>
        </GoogleAuth.Loaded>
        <GoogleAuth.Failed>
          <DisconnectPlaceButton {...{ googlePlace, disconnectPlace }}/>
        </GoogleAuth.Failed>
      </div>
    </div>
  );
}


function PlaceInfo({ googlePlace }) {
  const name    = googlePlace.name;
  const address = googlePlace.formatted_address;
  const phone   = googlePlace.formatted_phone_number;

  return (
    <div className="list block inset">
      <h3>Connected</h3>
      <p>
        <strong>{name}</strong><br/>
        {address}<br/>
        {phone}
      </p>
      <MapsLink {...{ googlePlace }}/>
    </div>
  );
}


function MapsLink({ googlePlace }) {
  const mapsURL = googlePlace.url;
  if (!mapsURL)
    return null;

  return (
    <p>
      <Link href={mapsURL} external>
        <i className="f7-icons">exit</i>
        View on Google Maps
      </Link>
    </p>
  );
}


function GmbConnectButton({ setOfflineAccessCode }) {
  const client = useClient();

  async function onClickSignIn() {
    const { code } = await client.grantOfflineAccess();
    setOfflineAccessCode(code);
  }

  return (
    <p className="buttons-row">
      <button className="button button-fill connect-button" onClick={onClickSignIn}>
        Connect to Google My Business
      </button>
    </p>
  );
}


function DisconnectPlaceButton({ googlePlace, disconnectPlace }) {
  const { name } = googlePlace;

  return (
    <ConfirmButton {...{
      label:             'Disconnect this location',
      className:         'disconnect-button',
      onConfirm:         disconnectPlace,
      confirmTitle:      'Disconnect Location',
      confirmSubtitle:   `Are you sure you want to disconnect ${name}?`,
      confirmButtonText: 'Disconnect'
    }}/>
  );
}


function ConnectGmb({
  business,
  statuses,
  googlePlace,
  offlineAccessCode,
  setOfflineAccessCode,
  saveGoogleLocation,
  navigateTo,
  progressStart,
  progressEnd
}) {

  async function saveLocation(googleLocation) {
    try {
      await saveGoogleLocation({
        googleLocation,
        offlineAccessCode
      });

      const isVerified    = getGoogleLocationIsVerified(googleLocation);
      const isServiceArea = isServiceAreaLocation(googleLocation);
      if (isVerified) {
        Swal.fire({
          text: 'Your location has been connected!',
          icon: 'success'
        });
      } else if (isServiceArea)
        navigateTo(`/${business.id}/settings/business_profile/google/address`);
      else
        navigateTo(`/${business.id}/settings/business_profile/google/verify`);

    } catch (error) {
      setOfflineAccessCode(null);
    }
  }

  const { result, resultStatus } = useAllLocations({ progressStart, progressEnd });

  if (resultStatus === 'pending')
    return null;
  else if (resultStatus === 'failed')
    return <LocationsFailedView/>;
  else {
    return <MatchLocationResultView {...{
      result,
      business,
      statuses,
      googlePlace,
      setOfflineAccessCode,
      saveLocation
    }}/>;
  }
}


function MatchLocationResultView({
  result,
  business,
  statuses,
  googlePlace,
  setOfflineAccessCode,
  saveLocation
}) {

  const match = result.find(({ location }) => getGoogleLocationPlaceID(location) === googlePlace.place_id);

  if (match)
    return <ConnectGmbMatch {...{ match, saveLocation }}/>;

  else {
    return <LocationResultView {...{
      business,
      statuses,
      result,
      setOfflineAccessCode,
      saveLocation
    }}/>;
  }
}


function ConnectGmbMatch({ match, saveLocation }) {
  const { location } = match;

  useEffect(function() {
    saveLocation(location);
  }, [ location.id ]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
